import styled from "styled-components";

export const MobileContainer = styled.div`
	height: auto;
	min-height: calc(100vh - 80px);
`;